export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;

/// Mesma allowlist do backend: evita esperar o upload inteiro para receber a recusa.
export const ACCEPTED_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

export const ACCEPT_ATTR = '.pdf,.jpg,.jpeg,.png';

export function validateAttachment(file: File): string | null {
    if (file.size > MAX_UPLOAD_BYTES) return 'tamanho';
    if (!ACCEPTED_TYPES.includes(file.type)) return 'formato';
    return null;
}
